module.exports = __webpack_public_path__ + "img/member-icon-3.8b4b2b9f.png";